import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import WelcomeTourMobile from './WelcomeTourMobile.tsx'

const WelcomeTour: React.FC = () => {
  const location = useLocation()
  const isActive = useSelector((state: any) => state.dashboard?.tutorial?.isActive) ?? false

  const isDashboardRoute =
    location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/')

  if (!isDashboardRoute || !isActive) return null

  return <WelcomeTourMobile />
}

export default WelcomeTour
